<!-- <svg
  class="w-12 h-12 animate-spin"
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  aria-hidden="true"
>
  <circle
    class="opacity-25"
    cx="12"
    cy="12"
    r="10"
    stroke="#DC9D2A"
    stroke-width="4"
  ></circle>
  <path
    class="opacity-75"
    fill="#DC9D2A"
    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
  ></path>
</svg> -->


<svg
  [ngClass]="size || 'w-12 h-12'"
  class="animate-spin"
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  aria-hidden="true"
>
  <circle
    class="opacity-25"
    cx="12"
    cy="12"
    r="10"
    [attr.stroke]="color || '#DC9D2A'"
    stroke-width="4"
  ></circle>

  <path
    class="opacity-75"
    [attr.fill]="color || '#DC9D2A'"
    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
  ></path>
</svg>